import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import stl from "./MobileFooter.module.css";
import { CDN_LINK } from "@globalConfig";
import useIsFirstInteraction from "@hooks/useIsFirstInteraction";
import useHelpers from "@hooks/useHelpers";
var MobileFooter = function MobileFooter() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  var isFirstInteraction = useIsFirstInteraction();
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.upperSection
  }, isFirstInteraction && /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/safety.svg",
    alt: "i",
    width: 50,
    height: 50
  }), /*#__PURE__*/React.createElement("p", null, t("شركة موقع سيارة للتجارة شركة موثقة لدى وزارة التجارة والاستثمار وبدعم من شركة علم, بسجل تجاري رقم 1010538980", {
    ns: "web_footer"
  })), isFirstInteraction && /*#__PURE__*/React.createElement("div", {
    className: stl.footerWithVat
  }, /*#__PURE__*/React.createElement("a", {
    className: stl.vatLink,
    href: CDN_LINK + "/assets/bundles/GAZT_VAT_Certificate.pdf",
    rel: "noopener noreferrer",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("img", {
    width: "30px",
    height: "38px",
    src: CDN_LINK + "/assets/images/Vat.svg",
    alt: "vat icon"
  })), /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/saudi_elm.svg",
    alt: "saudi_elm icon",
    width: "262px",
    height: "44px"
  }))), /*#__PURE__*/React.createElement("div", {
    className: stl.lowerSection
  }, /*#__PURE__*/React.createElement("a", {
    href: createUrl("/"),
    "aria-label": "Syarah logo",
    className: "disableOnWebView"
  }, isFirstInteraction && /*#__PURE__*/React.createElement("img", {
    style: {
      width: "83px"
    },
    src: CDN_LINK + "/assets/images/logogreyN.svg",
    alt: "Syarah logo",
    width: 83,
    height: 38,
    "aria-label": "Syarah logo"
  })), /*#__PURE__*/React.createElement("p", {
    className: "interActiveGray"
  }, t(" شركة سعوديه بسجل تجاري 1010538980 مصدره الرياض", {
    ns: "web_footer"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.paymentMethods
  }, isFirstInteraction && /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/bundles/greenArmor.svg",
    alt: "payments",
    width: 15,
    height: 17
  }), /*#__PURE__*/React.createElement("span", null, t("طرق دفع إلكترونية آمنة", {
    ns: "web_footer"
  })), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, isFirstInteraction && /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/bundles/Mada.svg",
    alt: "",
    width: 43,
    height: 26
  })), /*#__PURE__*/React.createElement("li", null, isFirstInteraction && /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/bundles/Visadark.svg",
    alt: "",
    width: 43,
    height: 26
  })), /*#__PURE__*/React.createElement("li", null, isFirstInteraction && /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/bundles/mc.svg",
    alt: "",
    width: 43,
    height: 26
  })), /*#__PURE__*/React.createElement("li", null, isFirstInteraction && /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/apple_pay.svg",
    alt: "",
    width: 42,
    height: 24
  })), /*#__PURE__*/React.createElement("li", null, isFirstInteraction && /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/g_pay.svg",
    alt: "",
    width: 42,
    height: 24
  })), /*#__PURE__*/React.createElement("li", null, isFirstInteraction && /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/bundles/Sadad.svg",
    alt: "",
    width: 43,
    height: 26
  })), /*#__PURE__*/React.createElement("li", null, isFirstInteraction && /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/bundles/paypalstacked.svg",
    alt: "",
    width: 43,
    height: 26
  })), /*#__PURE__*/React.createElement("li", null, isFirstInteraction && /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/bundles/BankTransfer.svg",
    alt: "",
    width: 43,
    height: 26
  })))), /*#__PURE__*/React.createElement("p", {
    className: "interActiveGray"
  }, t("جميع الحقوق محفوظة لشركة موقع سيارة المحدودة © 2022", {
    ns: "web_footer"
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.links)
  }, /*#__PURE__*/React.createElement("a", {
    rel: "noopener noreferrer",
    href: createUrl("/terms-landing"),
    className: "interActiveGray"
  }, t("الأحكام والشروط", {
    ns: "web_footer"
  }), " "), " ", "|", /*#__PURE__*/React.createElement("a", {
    rel: "noopener noreferrer",
    href: createUrl("/privacy-policy"),
    className: "interActiveGray"
  }, t("سياسة الخصوصية", {
    ns: "web_footer"
  }), " "), " ", "|", /*#__PURE__*/React.createElement("a", {
    rel: "noopener noreferrer",
    href: createUrl("/return-policy"),
    className: "interActiveGray"
  }, tShort("return_policy"))))));
};
export default MobileFooter;